export default __webpack_public_path__ + "static/assets/82072226e8cf716289165650c31eeda2.svg";